/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type {
  GetApiProjectprioritiesQueryResponse,
  GetApiProjectprioritiesQueryParams,
} from '../models/GetApiProjectpriorities.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { getApiProjectprioritiesQueryResponseSchema } from '../zod/getApiProjectprioritiesSchema.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const getApiProjectprioritiesQueryKey = (
  params: GetApiProjectprioritiesQueryParams,
) => [{ url: '/api/projectpriorities' }, ...(params ? [params] : [])] as const;

export type GetApiProjectprioritiesQueryKey = ReturnType<
  typeof getApiProjectprioritiesQueryKey
>;

/**
 * {@link /api/projectpriorities}
 */
export async function getApiProjectpriorities(
  params: GetApiProjectprioritiesQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectprioritiesQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: `/api/projectpriorities`,
    params,
    ...requestConfig,
  });
  return getApiProjectprioritiesQueryResponseSchema.parse(res.data);
}

export function getApiProjectprioritiesQueryOptions(
  params: GetApiProjectprioritiesQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectprioritiesQueryKey(params);
  return queryOptions<
    GetApiProjectprioritiesQueryResponse,
    ResponseErrorConfig<Error>,
    GetApiProjectprioritiesQueryResponse,
    typeof queryKey
  >({
    enabled: !!params,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectpriorities(params, config);
    },
  });
}

/**
 * {@link /api/projectpriorities}
 */
export function useGetApiProjectpriorities<
  TData = GetApiProjectprioritiesQueryResponse,
  TQueryData = GetApiProjectprioritiesQueryResponse,
  TQueryKey extends QueryKey = GetApiProjectprioritiesQueryKey,
>(
  params: GetApiProjectprioritiesQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectprioritiesQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & {
      client?: QueryClient;
    };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ?? getApiProjectprioritiesQueryKey(params);

  const query = useQuery(
    {
      ...getApiProjectprioritiesQueryOptions(params, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
